import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { HeartSvg } from "@/components/icons/legacy-svgs";
import React, { useContext } from "react";
import ExposeCard from "../Landingpage/ExposeCard";
import { FavoritesContext } from "../../lib/FavoritesContext"; // Import FavoritesContext
import { ScrollArea } from "@/components/ui/scroll-area"; // Import ScrollArea

export default function SideDropdown() {
  // Access favorites and handleFavoriteToggle from FavoritesContext
  const { favorites, handleFavoriteToggle } = useContext(FavoritesContext);

  return (
    <Sheet style={{ padding: 0 }}>
      <SheetTrigger>
        <HeartSvg
          className={` size-7 ${favorites.length >= 1 && "fill-prime-600"}`}
        />
        <span className="absolute bottom-1 -left-1 inline-flex items-center justify-center w-4 h-4 text-sm font-medium font-sans text-prime-700 bg-prime-200 rounded-full">
          {favorites.length}
        </span>
      </SheetTrigger>
      <SheetContent className="px-2 md:px-5">
        <SheetHeader className="text-left space-y-0">
          <SheetTitle>Favoriten</SheetTitle>
          <SheetDescription>Favorisierte Immobilien</SheetDescription>
        </SheetHeader>

        <ScrollArea className="mt-4 h-[calc(100vh-150px)]">
          {favorites.length === 0 ? (
            <p className="text-gray-500"><HeartSvg
            className={` size-7 `}
          />Favorisieren Sie Immobilien die Ihnen gefallen</p>
          ) : (
            favorites.map((estate) => (
              <ExposeCard
                className="my-5 bg-prime-50 rounded-lg"
                key={estate.id}
                image={estate.images?.[0]?.original || "/Haus.jpeg"}
                price={estate.price}
                base_rent={estate.base_rent}
                marketing_type={estate.marketing_type}
                location={`${estate.zip_code}, ${estate.city}`}
                details={`${estate.number_of_rooms} Zimmer, ${estate.living_space} m²`}
                description={estate.title}
                isFavorited={true} // Always true since it's in the favorites list
                onFavoriteToggle={() => handleFavoriteToggle(estate)}
                id={estate.id}
              />
            ))
          )}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
